import { Box, Stack, Typography } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'

import { CenteredLoading } from '../../components'
import { AuthorizationInfo } from '../../components/PrintableDocuments/AuthorizationInfo'
import { ConcernContainer } from '../../components/PrintableDocuments/ConcernContainer'
import { Header } from '../../components/PrintableDocuments/Header'
import { RepairOrderInfoHeader } from '../../components/PrintableDocuments/RepairOrderInfoHeader'
import { ServiceContainer } from '../../components/PrintableDocuments/ServiceContainer'
import { Totals } from '../../components/PrintableDocuments/Totals'
import { VehicleTireInfoSection } from '../../components/PrintableDocuments/VehicleTireInfoSection'
import { InvoiceContext } from '../../providers/InvoiceProvider/InvoiceContext'

export default function AuthorizationPDF() {
  const {
    shopProfile,
    repairOrder,
    serviceAdvisor,
    customer,
    vehicle,
    services,
    serviceInventoryParts
  } = useContext(InvoiceContext)

  const dataLoaded =
    shopProfile &&
    repairOrder &&
    serviceAdvisor !== undefined &&
    customer &&
    vehicle &&
    services &&
    serviceInventoryParts

  const [shopLogoLoaded, setShopLogoLoaded] = useState<boolean>(false)
  useEffect(() => {
    if (dataLoaded && shopLogoLoaded) {
      document.body.id = 'ready-to-print' // to sync with browserless.io for email attachment generation
      window.print()
    }
  }, [shopLogoLoaded, dataLoaded])

  return (
    <>
      {dataLoaded ? (
        <>
          <Stack
            direction="row"
            justifyContent="space-between"
            mx={2}
            sx={{ borderBottom: 1, borderColor: '#424242' }}>
            <Header
              shopProfile={shopProfile}
              alignLeft={true}
              shopImageLoadedCallback={() => setShopLogoLoaded(true)}
            />
            <RepairOrderInfoHeader
              repairOrder={repairOrder}
              serviceAdvisor={serviceAdvisor}
              variation="Authorization"
              date={repairOrder?.entry?.info?.invoiceDate}
            />
          </Stack>
          <AuthorizationInfo
            vehicle={vehicle}
            customer={customer}
            repairOrder={repairOrder}
          />
          <ConcernContainer repairOrder={repairOrder} />
          <ServiceContainer
            invoicePDF={false}
            repairOrder={repairOrder}
            services={services}
            inventoryParts={serviceInventoryParts}
            workOrderPDF={false}
          />
          <Totals invoicePDF={false} repairOrder={repairOrder} />
          {shopProfile?.info?.invoiceShowVehicleTire && (
            <VehicleTireInfoSection />
          )}
          <Box mx={2} mt={2}>
            <Typography variant="body2">
              I hereby authorize the repair work listed herein, including sublet
              work, to be done along with necessary materials. You and your
              employees may operate the described vehicle for the purposes of
              testing, inspection or delivery at my risk. An express lien is
              acknowledged on said vehicle to secure the amount of repairs
              thereto. You will not be held responsible for loss or damage to
              vehicle or articles left in vehicle in case of fire, theft,
              accident or any other cause beyond your control. Customer agrees
              to pay all collection costs and /or attorneys fees in the event
              that default is made in any payment due. If vehicle is returned to
              customer without repair service being performed, a diagnostic and
              handling fee (including reassembly) may be charged. I have read
              and understand the above and acknowledge receipt of an estimate. I
              hereby authorize the repair work listed herein.
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'row', mt: 5 }}>
              <Typography variant="body1" fontWeight="bold">
                Customer Signature:
              </Typography>
              <Box sx={{ borderBottom: 1, width: '50%' }}></Box>
            </Box>
          </Box>
        </>
      ) : (
        <CenteredLoading />
      )}
    </>
  )
}
